import { SkeletonText } from '@dev-spendesk/grapes';
import { fromNumber } from 'ezmoney';
import { Trans } from 'react-i18next';

import { QueryError } from 'common/components/QueryError';
import { QuerySuspense } from 'common/components/QuerySuspense';
import { useTranslation } from 'common/hooks/useTranslation';
import { useWalletTransactionForecastQuery } from 'modules/company/hooks';
import { useQueryStates } from 'src/core/api/hooks/useQueryStates';
import { useCompanyCurrency } from 'src/core/modules/app/hooks/useCompanyCurrency';
import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

import { useWalletTransactionForecastOnSelectedTransfersQuery } from '../../../hooks';

export const WalletBalance = () => {
  const { t } = useTranslation('global');
  const companyCurrency = useCompanyCurrency();

  const walletTransactionForecastOnSelectedTransfersQueryState =
    useWalletTransactionForecastOnSelectedTransfersQuery()();

  const walletTransactionForecastOnAvailableAllocationQueryState =
    useWalletTransactionForecastQuery()(
      fromNumber(0, companyCurrency, 2),
      'availableForNewRequests',
    );

  const queryStates = useQueryStates({
    states: {
      walletTransactionForecastOnSelectedTransfers:
        walletTransactionForecastOnSelectedTransfersQueryState,
      walletTransactionForecastOnAvailableAllocation:
        walletTransactionForecastOnAvailableAllocationQueryState,
    },
  });

  return (
    <QuerySuspense
      queryState={queryStates}
      loading={<SkeletonText />}
      fallback={(error) => (
        <QueryError
          queryError={error}
          componentType="Notification"
          translations={{
            serverError:
              'invoices.transfer.walletInformation.balanceQueryError',
            requestError: () =>
              'invoices.transfer.walletInformation.balanceQueryError',
          }}
        />
      )}
    >
      {({
        walletTransactionForecastOnSelectedTransfers,
        walletTransactionForecastOnAvailableAllocation,
      }) => {
        return walletTransactionForecastOnSelectedTransfers.hasEnoughFunds ? (
          <p className="body-l">
            <Trans
              i18nKey="invoices.transfer.walletInformation.availableBalance"
              values={{
                balance: formatMonetaryValue(
                  walletTransactionForecastOnAvailableAllocation.walletAmount,
                ),
              }}
              components={[
                // eslint-disable-next-line react/jsx-key
                <strong className="fw-semibold body-l" />,
              ]}
            />
          </p>
        ) : (
          <p className="body-l">
            {t('invoices.transfer.walletInformation.insufficientFunds')}
          </p>
        );
      }}
    </QuerySuspense>
  );
};
